module.exports = __webpack_public_path__ + "static/media/服务业务项目管理系统.e2bbce3c.png";